<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="[Contents]">
<h1 class="ct" id="d7e6899">
<b>[</b><span class="smallcaps">Contents</span><b>]</b>
</h1>
<p class="cct" id="d7e6949">
<a href="#/MacD_ISBN9781418573447_epub_c9_r1#d7e81911" id="d14e256">
<em>Acknowledgments</em>
</a>
</p>
<p class="cct" id="d7e6999">
<a href="#/MacD_ISBN9781418573447_epub_c11_r1#d7e99113" id="d14e260">
<em>Introduction:</em> You Have a Choice</a>
</p>
<p class="cct" id="d7e699a9">
<br/> <br/> </p>
<p class="cct" id="d7e7069">
<a href="#/MacD_ISBN9781418573447_epub_c12_r1#Anch0009" id="Anch00119">
<b>Part I—My Identity Choices</b>
</a>
</p>
<p class="cct" id="d7e7119">
<a href="#/MacD_ISBN9781418573447_epub_c13_r1#Anch0029" id="Anch00323">Choice 1: I Choose God’s Love</a>
</p>
<p class="cct" id="d7e7179">
<span href="#/MacD_ISBN9781418573447_epub_c14_r1#Anch0049" id="Anch00543" title="Link target outside of Sample">Choice 2: I Choose God’s Forgiveness</span>
</p>
<p class="cct" id="d7e699b9">
<br/> <br/> </p>
<p class="cct" id="d7e7229">
<b>
<span href="#/MacD_ISBN9781418573447_epub_c15_r1#Anch0069" id="Anch00771" title="Link target outside of Sample">Part II—My Authority Choices</span>
</b>
</p>
<p class="cct" id="d7e7279">
<span href="#/MacD_ISBN9781418573447_epub_c17_r1#Anch0089" id="Anch00975" title="Link target outside of Sample">Choice 3: I Choose Jesus Christ as Lord</span>
</p>
<p class="cct" id="d7e7329">
<span href="#/MacD_ISBN9781418573447_epub_c18_r1#Anch0109" id="Anch01199" title="Link target outside of Sample">Choice 4: I Choose the Bible as God’s Word</span>
</p>
<p class="cct" id="d7e699c9">
<br/> <br/> </p>
<p class="cct" id="d7e7379">
<b>
<span href="#/MacD_ISBN9781418573447_epub_c19_r1#Anch0149" id="Anch015131" title="Link target outside of Sample">Part III—My Capacity Choices</span>
</b>
</p>
<p class="cct" id="d7e7429">
<span href="#/MacD_ISBN9781418573447_epub_c21_r1#Anch0169" id="Anch017135" title="Link target outside of Sample">Choice 5: I Choose to Forgive</span>
</p>
<p class="cct" id="d7e7489">
<span href="#/MacD_ISBN9781418573447_epub_c25_r1#Anch0189" id="Anch019163" title="Link target outside of Sample">Choice 6: I Choose to Trust</span>
</p>
<p class="cct" id="d7e699d9">
<br/> <br/> </p>
<p class="cct" id="d7e7539">
<b>
<span href="#/MacD_ISBN9781418573447_epub_c26_r1#Anch0209" id="Anch021181" title="Link target outside of Sample">Part IV—My Priority Choices</span>
</b>
</p>
<p class="cct" id="d7e7589">
<span href="#/MacD_ISBN9781418573447_epub_c28_r1#Anch0229" id="Anch023185" title="Link target outside of Sample">Choice 7: I Choose to Love My Family First</span>
</p>
<p class="cct" id="d7e7639">
<span href="#/MacD_ISBN9781418573447_epub_c29_r1#Anch0249" id="Anch025209" title="Link target outside of Sample">Choice 8: I Choose to Be Authentic</span>
</p>
<p class="cct" id="d7e699e9">
<br/> <br/> </p>
<p class="cct" id="d7e77110">
<b>
<span href="#/MacD_ISBN9781418573447_epub_c30_r1#Anch02610" id="Anch027233" title="Link target outside of Sample">Part V—My Destiny Choices</span>
</b>
</p>
<p class="cct" id="d7e77610">
<span href="#/MacD_ISBN9781418573447_epub_c32_r1#Anch02810" id="Anch029237" title="Link target outside of Sample">Choice 9: I Choose to Serve</span>
</p>
<p class="cct" id="d7e78110">
<span href="#/MacD_ISBN9781418573447_epub_c33_r1#Anch03010" id="Anch031261" title="Link target outside of Sample">Choice 10: I Choose to Stand</span>
</p>
<p class="cct" id="d7e699f9">
<br/> <br/> </p>
<p class="cct" id="d7e78610">
<em>
<span href="#/MacD_ISBN9781418573447_epub_c34_r1#Anch03210" id="Anch033283" title="Link target outside of Sample">Epilogue</span>
</em>
</p>
<p class="cct" id="d7e79110">
<span href="#/MacD_ISBN9781418573447_epub_c35_r1#Anch03410" id="Anch035288" title="Link target outside of Sample">
<em>Appendix A:</em> That’s My King</span>
</p>
<p class="cct" id="d7e79910">
<span href="#/MacD_ISBN9781418573447_epub_c36_r1#Anch03610" id="Anch037290" title="Link target outside of Sample">
<em>Appendix B:</em> Scriptures to Pray</span>
</p>
<p class="cct" id="d7e80610">
<em>
<span href="#/MacD_ISBN9781418573447_epub_c38_r1#Anch03810" id="Anch039293" title="Link target outside of Sample">Notes</span>
</em>
</p>
<p class="cct" id="d7e81110">
<em>
<span href="#/MacD_ISBN9781418573447_epub_c39_r1#Anch04010" id="Anch041296" title="Link target outside of Sample">About the Author</span>
</em>
</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MacD_ISBN9781418573447_epub_c7_r1.vue?5baf5b14